
export default {
  provide() {
    return {
      Breadcrumb: this,
    };
  },

  props: {
    separator: {
      type: String,
      default: '/',
    },
  },

  mounted() {
    const items = this.$el.querySelectorAll('.BreadcrumbItem');
    if (items.length) {
      items[items.length - 1].setAttribute('aria-current', 'page');
    }
  },
};
